import { render, staticRenderFns } from "./CompanyRequestSuppressionChangeModal.vue?vue&type=template&id=be33da56&"
import script from "./CompanyRequestSuppressionChangeModal.vue?vue&type=script&lang=js&"
export * from "./CompanyRequestSuppressionChangeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports